<template>
  <b-modal
    ref="confirmationModal"
    :visible="shown"
    centered
    title="Potwierdzenie"
    @hidden="hide"
    @hide="cancel"
  >
    <div class="form-horizontal" style="word-wrap: break-word;">
      <span v-html="message"></span>
    </div>
    <div slot="modal-footer">
      <b-btn variant="primary" @click="ok">Tak</b-btn>
      <b-btn variant="outline-secondary" @click="cancel">Nie</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LayerActivationConfirmationModal',
  data: function() {
    return {
      shown: false,
      message: undefined,
      ok: function() {},
      cancel: function() {}
    };
  },
  computed: {
    ...mapGetters(['showConfirmationModal'])
  },
  watch: {
    showConfirmationModal(value) {
      if (value) {
        const confirmationData = this.$store.getters.confirmation;
        this.setMessage(confirmationData.message);
        this.setYesAction(confirmationData.yesAction);
        this.setNoAction(confirmationData.noAction);
        this.show();
      }
    }
  },
  methods: {
    setMessage(message) {
      this.message = message;
    },
    setYesAction(action) {
      const self = this;

      self.ok = function() {
        action();
        self.hide();
      };
    },
    setNoAction(action) {
      const self = this;

      self.cancel = function() {
        if (action) {
          action();
        }
        self.hide();
      };
    },
    show() {
      this.shown = true;
    },
    hide() {
      this.shown = false;
    }
  }
};
</script>
